import AdminNavBar from "./AdminNavBar";
import TimesheetNavBar from "./TimesheetNavBar";

const Timesheets = () => {
	return (
		<div className="resilire">
			<AdminNavBar />
			<TimesheetNavBar />
		</div>
	)
}
export default Timesheets;
